module.exports = __webpack_public_path__ + "static/media/MVNZ_web_5_preview.b1736b33.jpg";